import React, { useState, useEffect } from "react";
import { Button } from "./Button";
import { evaluate } from "mathjs";
const Calculator = () => {
  const [screenInput, setScreenInput] = useState("");
  const [flash, setFlash] = useState(null);
  useEffect(() => {
    setTimeout(() => setFlash(null), 2000);
  }, [flash]);
  const handleSetResult = () => {
    try {
      const newInput = evaluate(screenInput);
      setScreenInput(newInput);
    } catch (err) {
      setFlash("please enter correct expression ");
    }
  };
  return (
    <div>
      <div className="box ">Welcome To Calculator</div>
      {flash && <div className="box flash">{flash}</div>}
      <div className="calc-wraper">
        <div className="calc-screen">{screenInput}</div>
        <div className="row">
          <Button onClick={(val) => setScreenInput(screenInput + val)}>
            7
          </Button>
          <Button onClick={(val) => setScreenInput(screenInput + val)}>
            8
          </Button>
          <Button onClick={(val) => setScreenInput(screenInput + val)}>
            9
          </Button>
          <Button onClick={(val) => setScreenInput(screenInput + val)}>
            -
          </Button>
        </div>
        <div className="row">
          <Button onClick={(val) => setScreenInput(screenInput + val)}>
            4
          </Button>
          <Button onClick={(val) => setScreenInput(screenInput + val)}>
            5
          </Button>
          <Button onClick={(val) => setScreenInput(screenInput + val)}>
            6
          </Button>
          <Button onClick={(val) => setScreenInput(screenInput + val)}>
            +
          </Button>
        </div>
        <div className="row">
          <Button onClick={(val) => setScreenInput(screenInput + val)}>
            1
          </Button>
          <Button onClick={(val) => setScreenInput(screenInput + val)}>
            2
          </Button>
          <Button onClick={(val) => setScreenInput(screenInput + val)}>
            3
          </Button>
          <Button onClick={(val) => setScreenInput(screenInput + val)}>
            *
          </Button>
        </div>
        <div className="row">
          <Button onClick={(val) => setScreenInput(screenInput + val)}>
            .
          </Button>
          <Button onClick={(val) => setScreenInput(screenInput + val)}>
            0
          </Button>
          <Button onClick={handleSetResult}>=</Button>
          <Button onClick={(val) => setScreenInput(screenInput + val)}>
            /
          </Button>
        </div>
        <div className="row">
          <div
            className="btn btn-c"
            onClick={() => setScreenInput((i) => i.slice(0, -1))}
          >
            C
          </div>
          <div className="btn btn-clear" onClick={() => setScreenInput("")}>
            Clear
          </div>
        </div>
      </div>
    </div>
  );
};

export default Calculator;
